import api from '../../../services/Api';
import { IAuditoriaLancamentoEstornoResultado } from '../interfaces/IAuditoriaLancamentoEstorno';

export const AuditoriaLancamentoEstornoService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaLancamentoEstornoResultado> {
    const response = await api.get<IAuditoriaLancamentoEstornoResultado>('auditoria-lancamento-estorno/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        totalLancamentosAnalisados: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoContabil: '',
        lancamentosEstorno: [],
      }
    );
  },
};
